<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="this.visibilityChange"
  >
    <CSidebarBrand class="mb-5">
      <svg
        width="170px"
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1920 513.35"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path
              class="cls-1"
              d="m19.99,191.37c11.04,0,19.99-8.95,19.99-19.99v-83.57c0-26.37,21.45-47.83,47.83-47.83h83.58c11.04,0,19.99-8.95,19.99-19.99S182.43,0,171.39,0h-83.58C39.39,0,0,39.39,0,87.81v83.57c0,11.04,8.95,19.99,19.99,19.99Z"
            />
            <path
              class="cls-2"
              d="m493.36,236.68h-118.34s0,0,0,0h-1.14c-53.69,0-97.21-43.52-97.21-97.21v-.18c0-9.34-5.95-18.16-15.03-20.35-13.19-3.17-24.95,6.74-24.95,19.39v.95c0,53.79-43.61,97.4-97.4,97.4h0s0,0,0,0H19.99c-11.04,0-19.99,8.95-19.99,19.99s8.95,19.99,19.99,19.99h118.36c54.31,0,98.34,44.04,98.34,98.35h0c0,12.66,11.76,22.57,24.95,19.4,9.09-2.18,15.03-11,15.03-20.35v-.19c0-53.69,43.52-97.21,97.2-97.21h119.49c11.04,0,19.99-8.95,19.99-19.99s-8.95-19.99-19.99-19.99Z"
            />
            <path
              class="cls-1"
              d="m425.55,0h-83.57c-11.04,0-19.99,8.95-19.99,19.99s8.95,19.99,19.99,19.99h83.57c26.37,0,47.83,21.45,47.83,47.83v83.57c0,11.04,8.95,19.99,19.99,19.99s19.99-8.95,19.99-19.99v-83.57c0-48.42-39.39-87.81-87.81-87.81Z"
            />
            <path
              class="cls-1"
              d="m493.36,321.98c-11.04,0-19.99,8.95-19.99,19.99v83.57c0,26.37-21.45,47.83-47.83,47.83h-83.57c-11.04,0-19.99,8.95-19.99,19.99s8.95,19.99,19.99,19.99h83.57c48.42,0,87.81-39.39,87.81-87.81v-83.57c0-11.04-8.95-19.99-19.99-19.99Z"
            />
            <path
              class="cls-1"
              d="m171.39,473.37h-83.58c-26.37,0-47.83-21.45-47.83-47.83v-83.57c0-11.04-8.95-19.99-19.99-19.99S0,330.93,0,341.97v83.57c0,48.42,39.39,87.81,87.81,87.81h83.58c11.04,0,19.99-8.95,19.99-19.99s-8.95-19.99-19.99-19.99Z"
            />
            <g>
              <path
                class="cls-1"
                d="m768.5,393.58c3.47,5.51,4.44,10.46,2.91,14.85-1.53,4.39-4.49,7.66-8.88,9.81-4.39,2.14-9.09,2.7-14.09,1.68-5-1.02-9.24-4.28-12.71-9.8l-21.14-34.01c-5.72-9.39-15.42-14.09-29.1-14.09-20.83,0-39.01-4.6-54.53-13.78-15.52-9.19-27.57-22.11-36.15-38.75-8.58-16.65-12.87-36.2-12.87-58.67s4.29-42.27,12.87-58.81c8.58-16.54,20.62-29.36,36.15-38.45,15.52-9.08,33.8-13.63,54.83-13.63s39.31,4.55,54.84,13.63c15.52,9.09,27.57,21.9,36.15,38.45,8.58,16.54,12.86,36.04,12.86,58.51,0,24.51-5.06,45.54-15.16,63.11-10.11,17.56-24.05,30.43-41.82,38.6,4.49,1.64,8.53,4.09,12.1,7.35,3.57,3.26,7.1,7.66,10.57,13.17l13.17,20.83Zm-82.71-65.25c19.81,0,35.23-6.84,46.26-20.53,11.03-13.68,16.54-32.67,16.54-56.98s-5.47-43.5-16.39-56.97c-10.93-13.48-26.4-20.22-46.41-20.22s-35.23,6.74-46.26,20.22c-11.03,13.48-16.54,32.47-16.54,56.97s5.51,43.3,16.54,56.98c11.03,13.69,26.45,20.53,46.26,20.53Z"
              />
              <path
                class="cls-1"
                d="m837.73,361.42c-13.07,0-19.61-6.74-19.61-20.22v-178.29c0-13.27,6.64-19.91,19.91-19.91h73.83c23.69,0,41.97,5.67,54.83,17,12.86,11.33,19.3,27.22,19.3,47.63,0,16.14-4.19,29.46-12.56,39.98-8.37,10.52-20.42,17.61-36.15,21.29,10.41,3.26,18.99,11.13,25.73,23.59l22.97,42.58c3.47,6.54,4.14,12.56,1.99,18.08-2.14,5.51-7.4,8.27-15.77,8.27-5.51,0-10.01-1.18-13.48-3.53-3.47-2.35-6.54-5.97-9.19-10.87l-30.94-56.98c-3.68-6.94-8.02-11.58-13.02-13.94-5-2.35-11.38-3.52-19.15-3.52h-29.1v68.62c0,13.48-6.54,20.22-19.61,20.22Zm19.61-117.94h47.79c28.59,0,42.89-11.64,42.89-34.93s-14.3-34.62-42.89-34.62h-47.79v69.54Z"
              />
              <path
                class="cls-1"
                d="m1139.16,362.03c-22.47,0-41.71-4.54-57.74-13.63-16.03-9.08-28.34-21.95-36.91-38.6-8.58-16.65-12.87-36.3-12.87-58.97s4.29-42.27,12.87-58.81c8.58-16.54,20.88-29.36,36.91-38.45,16.03-9.08,35.28-13.63,57.74-13.63,11.23,0,22.26,1.43,33.09,4.29,10.82,2.86,20.32,6.94,28.49,12.25,5.31,3.47,8.47,7.61,9.5,12.4,1.02,4.81.41,9.19-1.84,13.17-2.25,3.99-5.62,6.64-10.11,7.97-4.5,1.33-9.5.16-15.01-3.52-6.33-4.08-13.17-7.05-20.52-8.89-7.35-1.84-14.81-2.76-22.36-2.76-21.86,0-38.5,6.59-49.93,19.76-11.44,13.17-17.16,31.91-17.16,56.21s5.72,43.1,17.16,56.37c11.44,13.27,28.08,19.91,49.93,19.91,7.76,0,15.42-.97,22.97-2.91,7.55-1.93,14.7-4.95,21.44-9.04,5.51-3.47,10.41-4.6,14.7-3.37,4.29,1.22,7.51,3.72,9.65,7.5,2.14,3.78,2.8,7.92,1.99,12.41-.82,4.49-3.58,8.47-8.27,11.95-8.17,5.92-17.92,10.47-29.25,13.63-11.33,3.16-22.82,4.74-34.46,4.74Z"
              />
              <path
                class="cls-1"
                d="m1300.91,362.03c-15.52,0-29-3.16-40.44-9.5-11.44-6.33-20.32-15.36-26.65-27.11-6.33-11.75-9.5-25.58-9.5-41.51s3.16-29.72,9.5-41.35c6.33-11.64,15.21-20.63,26.65-26.96,11.44-6.33,24.91-9.5,40.44-9.5s29,3.16,40.44,9.5c11.44,6.33,20.32,15.31,26.65,26.96,6.33,11.64,9.5,25.42,9.5,41.35s-3.17,29.76-9.5,41.51c-6.33,11.75-15.22,20.78-26.65,27.11-11.44,6.33-24.92,9.5-40.44,9.5Zm0-29.1c11.44,0,20.62-4.14,27.57-12.41,6.94-8.27,10.42-20.47,10.42-36.6s-3.48-28.54-10.42-36.61c-6.94-8.06-16.13-12.1-27.57-12.1s-20.63,4.03-27.57,12.1c-6.95,8.07-10.42,20.28-10.42,36.61s3.47,28.34,10.42,36.6c6.94,8.27,16.13,12.41,27.57,12.41Z"
              />
              <path
                class="cls-1"
                d="m1458.05,362.03c-13.07,0-24.56-3.16-34.46-9.5-9.91-6.33-17.62-15.36-23.13-27.11-5.51-11.75-8.27-25.58-8.27-41.51s2.76-29.97,8.27-41.51c5.51-11.54,13.22-20.47,23.13-26.8,9.9-6.33,21.39-9.5,34.46-9.5,10.61,0,20.22,2.35,28.79,7.04,8.58,4.7,15.01,10.93,19.3,18.69v-71.99c0-12.87,6.33-19.3,18.99-19.3s19.3,6.43,19.3,19.3v181.97c0,13.07-6.33,19.61-18.99,19.61s-18.99-6.54-18.99-19.61v-6.43c-4.29,8.17-10.72,14.65-19.3,19.45-8.58,4.8-18.28,7.2-29.1,7.2Zm10.72-29.1c11.44,0,20.62-4.14,27.57-12.41,6.94-8.27,10.42-20.47,10.42-36.6s-3.48-28.54-10.42-36.61c-6.94-8.06-16.13-12.1-27.57-12.1s-20.63,4.03-27.57,12.1c-6.95,8.07-10.42,20.28-10.42,36.61s3.47,28.34,10.42,36.6c6.94,8.27,16.13,12.41,27.57,12.41Z"
              />
              <path
                class="cls-1"
                d="m1593.45,178.53c-7.15,0-12.71-1.78-16.7-5.36-3.98-3.57-5.97-8.52-5.97-14.85s1.99-11.54,5.97-15.01c3.98-3.47,9.55-5.21,16.7-5.21,15.11,0,22.67,6.74,22.67,20.22s-7.56,20.21-22.67,20.21Zm0,182.58c-6.13,0-10.83-1.84-14.09-5.51-3.27-3.68-4.9-8.78-4.9-15.31v-112.43c0-13.89,6.33-20.83,18.99-20.83s19.3,6.94,19.3,20.83v112.43c0,6.54-1.64,11.64-4.9,15.31-3.27,3.68-8.07,5.51-14.4,5.51Z"
              />
              <path
                class="cls-1"
                d="m1716.29,362.03c-16.95,0-31.55-3.16-43.8-9.5-12.25-6.33-21.7-15.31-28.34-26.96-6.64-11.64-9.96-25.42-9.96-41.35s3.22-29.1,9.65-40.74c6.43-11.64,15.31-20.78,26.65-27.42,11.34-6.64,24.25-9.96,38.75-9.96,21.24,0,38.04,6.74,50.39,20.21,12.35,13.48,18.53,31.86,18.53,55.14,0,7.56-4.9,11.33-14.71,11.33h-92.51c2.86,26.76,18.18,40.13,45.95,40.13,5.31,0,11.28-.66,17.92-1.99,6.63-1.33,12.92-3.63,18.84-6.89,5.31-3.07,9.8-4.03,13.48-2.91,3.68,1.13,6.28,3.33,7.81,6.59,1.53,3.26,1.73,6.89.61,10.87-1.13,3.98-4.03,7.4-8.73,10.26-7.15,4.49-15.37,7.81-24.66,9.96-9.3,2.15-17.92,3.22-25.89,3.22Zm-5.51-129.89c-11.24,0-20.33,3.48-27.27,10.42-6.94,6.94-11.13,16.34-12.56,28.18h75.36c-.82-12.46-4.24-22.01-10.26-28.64-6.03-6.64-14.45-9.96-25.27-9.96Z"
              />
              <path
                class="cls-1"
                d="m1855.97,362.03c-8.78,0-18.08-.92-27.88-2.76-9.8-1.84-18.59-5-26.34-9.5-4.29-2.45-6.94-5.46-7.96-9.04-1.02-3.57-.87-6.94.46-10.11,1.32-3.16,3.57-5.46,6.74-6.89,3.17-1.43,6.89-1.12,11.18.92,8.17,3.89,15.82,6.59,22.97,8.12,7.15,1.53,14.19,2.29,21.14,2.29,9.8,0,17.1-1.68,21.9-5.05,4.8-3.37,7.2-7.81,7.2-13.33,0-8.58-6.33-14.09-18.99-16.54l-30.63-5.82c-25.94-4.9-38.91-18.38-38.91-40.44,0-9.81,2.71-18.27,8.12-25.42,5.41-7.15,12.91-12.67,22.52-16.54,9.6-3.88,20.62-5.82,33.09-5.82,17.97,0,34,3.98,48.09,11.94,3.88,2.05,6.18,4.86,6.89,8.43.71,3.58.31,6.95-1.23,10.11-1.53,3.17-3.93,5.41-7.2,6.74-3.27,1.33-7.05.97-11.33-1.07-6.33-3.26-12.41-5.61-18.23-7.04-5.82-1.43-11.39-2.15-16.7-2.15-10.01,0-17.41,1.74-22.21,5.21-4.8,3.47-7.2,8.07-7.2,13.79,0,8.99,5.82,14.5,17.46,16.54l30.63,5.83c13.27,2.45,23.33,6.94,30.18,13.48,6.84,6.54,10.26,15.31,10.26,26.34,0,14.91-5.82,26.61-17.46,35.08-11.64,8.47-27.16,12.71-46.56,12.71Z"
              />
            </g>
          </g>
        </g>
      </svg>
      <img :src="closeSidebarArrow" class="cursor-pointer" @click="closeSidebar" />
    </CSidebarBrand>
    <AppSidebarNav />
    <!-- <div class="qr-settings-sidebar">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4301 10.9756C17.4701 10.6556 17.5001 10.3356 17.5001 9.99561C17.5001 9.65561 17.4701 9.33561 17.4301 9.01561L19.5401 7.36561C19.7301 7.21561 19.7801 6.9456 19.6601 6.72561L17.6601 3.26561C17.5701 3.10561 17.4001 3.01561 17.2201 3.01561C17.1601 3.01561 17.1001 3.02561 17.0501 3.04561L14.5601 4.04561C14.0401 3.64561 13.4801 3.31561 12.8701 3.06561L12.4901 0.415606C12.4601 0.175606 12.2501 -0.00439453 12.0001 -0.00439453H8.00008C7.75008 -0.00439453 7.54008 0.175606 7.51008 0.415606L7.13008 3.06561C6.52008 3.31561 5.96008 3.65561 5.44008 4.04561L2.95008 3.04561C2.89008 3.02561 2.83008 3.01561 2.77008 3.01561C2.60008 3.01561 2.43008 3.10561 2.34008 3.26561L0.340084 6.72561C0.210084 6.9456 0.270084 7.21561 0.460084 7.36561L2.57008 9.01561C2.53008 9.33561 2.50008 9.66561 2.50008 9.99561C2.50008 10.3256 2.53008 10.6556 2.57008 10.9756L0.460084 12.6256C0.270084 12.7756 0.220084 13.0456 0.340084 13.2656L2.34008 16.7256C2.43008 16.8856 2.60008 16.9756 2.78008 16.9756C2.84008 16.9756 2.90008 16.9656 2.95008 16.9456L5.44008 15.9456C5.96008 16.3456 6.52008 16.6756 7.13008 16.9256L7.51008 19.5756C7.54008 19.8156 7.75008 19.9956 8.00008 19.9956H12.0001C12.2501 19.9956 12.4601 19.8156 12.4901 19.5756L12.8701 16.9256C13.4801 16.6756 14.0401 16.3356 14.5601 15.9456L17.0501 16.9456C17.1101 16.9656 17.1701 16.9756 17.2301 16.9756C17.4001 16.9756 17.5701 16.8856 17.6601 16.7256L19.6601 13.2656C19.7801 13.0456 19.7301 12.7756 19.5401 12.6256L17.4301 10.9756ZM15.4501 9.26561C15.4901 9.57561 15.5001 9.78561 15.5001 9.99561C15.5001 10.2056 15.4801 10.4256 15.4501 10.7256L15.3101 11.8556L16.2001 12.5556L17.2801 13.3956L16.5801 14.6056L15.3101 14.0956L14.2701 13.6756L13.3701 14.3556C12.9401 14.6756 12.5301 14.9156 12.1201 15.0856L11.0601 15.5156L10.9001 16.6456L10.7001 17.9956H9.30008L9.11008 16.6456L8.95008 15.5156L7.89008 15.0856C7.46008 14.9056 7.06008 14.6756 6.66008 14.3756L5.75008 13.6756L4.69008 14.1056L3.42008 14.6156L2.72008 13.4056L3.80008 12.5656L4.69008 11.8656L4.55008 10.7356C4.52008 10.4256 4.50008 10.1956 4.50008 9.99561C4.50008 9.79561 4.52008 9.56561 4.55008 9.26561L4.69008 8.13561L3.80008 7.43561L2.72008 6.59561L3.42008 5.38561L4.69008 5.89561L5.73008 6.31561L6.63008 5.63561C7.06008 5.31561 7.47008 5.07561 7.88008 4.90561L8.94008 4.47561L9.10008 3.34561L9.30008 1.99561H10.6901L10.8801 3.34561L11.0401 4.47561L12.1001 4.90561C12.5301 5.08561 12.9301 5.31561 13.3301 5.61561L14.2401 6.31561L15.3001 5.88561L16.5701 5.37561L17.2701 6.58561L16.2001 7.43561L15.3101 8.13561L15.4501 9.26561ZM10.0001 5.99561C7.79008 5.99561 6.00008 7.78561 6.00008 9.99561C6.00008 12.2056 7.79008 13.9956 10.0001 13.9956C12.2101 13.9956 14.0001 12.2056 14.0001 9.99561C14.0001 7.78561 12.2101 5.99561 10.0001 5.99561ZM10.0001 11.9956C8.90008 11.9956 8.00008 11.0956 8.00008 9.99561C8.00008 8.89561 8.90008 7.99561 10.0001 7.99561C11.1001 7.99561 12.0001 8.89561 12.0001 9.99561C12.0001 11.0956 11.1001 11.9956 10.0001 11.9956Z"
          fill="#727272"
        />
      </svg>
      <div class="qr-sidebar-settings">Settings</div>
    </div> -->

    <div class="qr-sidebar-separator"></div>
    <div class="qr-sidebar-session-info">
      <div
        style="
          width: 50px;
          height: 50px;
          overflow: hidden;
          border-radius: 200px;
          position: relative;
        "
      >
        <img
          style="
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 200px;
          "
          src="../assets/images/Profile_image.jpg"
        />
      </div>
      <div class="qr-sidebar-session-user">
        <div class="qr-sidebar-session-name">{{ this.$store.state.name }}</div>
        <div class="qr-sidebar-session-email">{{ this.$store.state.user }}</div>
      </div>
      <div class="qr-sidebar-session-icon" @click="logout">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 2H8C8.55 2 9 1.55 9 1C9 0.45 8.55 0 8 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H8C8.55 18 9 17.55 9 17C9 16.45 8.55 16 8 16H2V2Z"
            fill="#565656"
          />
          <path
            d="M17.65 8.65003L14.86 5.86003C14.54 5.54003 14 5.76003 14 6.21003V8.00003H7C6.45 8.00003 6 8.45003 6 9.00003C6 9.55003 6.45 10 7 10H14V11.79C14 12.24 14.54 12.46 14.85 12.14L17.64 9.35003C17.84 9.16003 17.84 8.84003 17.65 8.65003Z"
            fill="#565656"
          />
        </svg>
      </div>
    </div>

    <!-- <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    /> -->
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { cilSettings } from '@/assets/icons/index'
import { sygnet } from '@/assets/brand/sygnet'
import { mapState } from 'vuex'
import screenSize from '../utils/screenSize'
import closeSidebarIcon from '@/assets/icons/closeSidebar.svg'
import store from '../store/index'
import './sidebar.css'

export default {
  data() {
    return {
      name: this.$store.state.name,
      screenSize: screenSize(),
      closeSidebarArrow: closeSidebarIcon,
      variable: false,
    }
  },
  beforeUnmount() {
    // Si es necesario, puedes limpiar el event listener aquí
    window.removeEventListener('resize', this.screenSize.handleResize)
  },
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      cilSettings,
    }
  },
  computed: {
    ...mapState(['sidebarVisible', 'accessType']),
  },
  methods: {
    visibilityChange(isVisible){
      store.commit({ type: 'updateSidebarVisible', value: isVisible })
    },
    async logout() {
      const url = this.accessType === "employee" ? "pages/login?employee=true" : "pages/login"
      await this.$store.dispatch('logout')
      this.$router.push(url)
    },

    closeSidebar() {
      store.commit({ type: 'updateSidebarVisible', value: false })
    },

    getFirstLetters(name) {
      // Dividir el nombre en palabras
      const newName = name.split(' ')
      // Obtener la primera letra de cada palabra y unirlas
      const letters = newName
        .map((newName) => newName.charAt(0).toUpperCase())
        .join('')
      console.log(letters)
      return letters
    },
  },
}
</script>

<style scoped>
.cls-1 {
  fill: #17252a;
}

.cls-1,
.cls-2 {
  stroke-width: 0px;
}

.cls-2 {
  fill: #3aafa9;
}
</style>
